import { useCallback, useContext, useEffect, useState } from 'react';

// Hooks
import useInterval from '../../../../packages/hooks/useInterval';
import useAbortController from '../../../../packages/hooks/useAbortController';

// Contexts
import FootballApiContext from '../contexts/FootballApiContext';

// Constants
import refreshTimes from '../../../../packages/constants/refreshTimes';

// Types
import { IRule, IStandingsConfig, IStageResponseData, IStageResponse } from '../../../../packages/types';
import { IGeneralSubscriberInfo } from '../../../../packages/constants/subscribeTypes';
import useSubscriptionClick from '../../../../packages/hooks/useSubscriptionClick';

interface IUseStageArgs extends IGeneralSubscriberInfo {
  stageId?: string | number;
  competitionId?: string | number;
  seasonId?: string | number;
  stageType?: string;
  dataRefreshTime?: IStandingsConfig['dataRefreshTime'];
  dataGroups?: IStandingsConfig['dataGroups'];
  dataOffset?: IStandingsConfig['dataOffset'];
  dataLimit?: IStandingsConfig['dataLimit'];
}

export default function useStage({
  subscribers,
  dataWidgetId,
  dataWidgetSport,
  stageId,
  competitionId,
  seasonId,
  stageType,
  dataRefreshTime,
  dataGroups,
  dataWidgetCuid,
  dataOffset,
  dataLimit,
}: IUseStageArgs) {
  const { $stage } = useContext(FootballApiContext);
  const [stage, setStage] = useState<IStageResponse>();
  const [rules, setRules] = useState<IRule[]>();
  const interval = refreshTimes[dataRefreshTime || 'never'];
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [getSignal] = useAbortController();

  const fetchStage = useCallback(
    (manageLoader: boolean) => {
      if (stageId || competitionId || seasonId) {
        const signal = getSignal();
        manageLoader && setIsLoading(true);
        $stage
          ?.getStage({ signal, dataGroups, stageId, competitionId, seasonId, stageType, dataOffset, dataLimit })
          ?.then((stageResponse: IStageResponseData) => {
            manageLoader && setIsLoading(false);
            setStage(stageResponse?.stage);
            setRules(stageResponse?.rules);
          })
          .catch((error: unknown) => {
            console.error(error);
          });
      }
    },
    [$stage, competitionId, dataGroups, getSignal, seasonId, stageId, stageType, dataLimit, dataOffset],
  );

  const refetchWidgetData = useCallback(() => {
    fetchStage(false);
  }, [fetchStage]);

  useInterval(() => {
    refetchWidgetData();
  }, interval);

  useEffect(() => {
    fetchStage(true);
  }, [fetchStage]);
  const showWidget = true;
  return {
    showWidget,
    widgetData: { stage, rules, isLoading },
    handleClick: useSubscriptionClick({ dataWidgetId, dataWidgetSport, dataWidgetCuid, subscribers }),
    refetchWidgetData,
  };
}
